import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/nuxt-assets/favicon2.png")